import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';
import { addMonths, monthLabel } from '../../lib/calendarDates';
import {
  EMPTY_POST_FILTERS,
  PostsCalendar,
  type PostsCalendarFilters,
} from '../socialPosts/PostsCalendar';
import { ClientShareLinkCard } from './ClientShareLinkCard';

/**
 * The client's own content calendar: its posts only, plus the link (with PIN)
 * the client uses to see and approve them.
 */
export function ClientCalendarTab({ clientId }: { clientId: string }) {
  const { locale } = useI18n();
  const now = new Date();
  const [month, setMonth] = useState({ year: now.getFullYear(), month: now.getMonth() });
  const [filters, setFilters] = useState<PostsCalendarFilters>(EMPTY_POST_FILTERS);

  function shift(direction: 1 | -1) {
    setMonth((m) => {
      const next = addMonths(new Date(m.year, m.month, 1), direction);
      return { year: next.getFullYear(), month: next.getMonth() };
    });
  }

  return (
    <div className="space-y-4">
      <ClientShareLinkCard clientId={clientId} />

      <div className="flex items-center gap-2">
        <div className="inline-flex items-center rounded border border-gray-300 p-0.5">
          <button
            type="button"
            onClick={() => shift(-1)}
            aria-label="Luna trecută"
            className="rounded p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
          >
            <ChevronLeft size={16} />
          </button>
          <button
            type="button"
            onClick={() => setMonth({ year: now.getFullYear(), month: now.getMonth() })}
            className="rounded px-2.5 py-1 text-sm text-gray-700 hover:bg-gray-100"
          >
            Azi
          </button>
          <button
            type="button"
            onClick={() => shift(1)}
            aria-label="Luna viitoare"
            className="rounded p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
          >
            <ChevronRight size={16} />
          </button>
        </div>
        <span className="text-sm font-semibold capitalize text-gray-900">
          {monthLabel(locale, month.year, month.month)}
        </span>
      </div>

      <PostsCalendar
        year={month.year}
        month={month.month}
        filters={filters}
        onFiltersChange={setFilters}
        lockedClientId={clientId}
      />
    </div>
  );
}
